import type { ParsedLocation } from '@tanstack/react-router';
import { redirect } from '@tanstack/react-router';
import type { RouterContext } from '../routes/__root';

export { createFileRoute, createRootRouteWithContext, createRouter, redirect, useRouter } from '@tanstack/react-router';

/**
 * Default redirect destination for authenticated users visiting unauthenticated-only routes
 * (e.g., /login, /sign-up, /accept-invite)
 */
export const AUTHENTICATED_HOME_ROUTE = '/app/home' as const;

export const redirectUnauthenticated = ({
  context,
  location,
}: {
  context: RouterContext;
  location: ParsedLocation;
}) => {
  if (!context.authentication?.isAuthenticated) {
    throw redirect({
      search: { redirect: location.href },
      to: '/login',
    });
  }
};
